<script src="https://cdn.jsdelivr.net/npm/chart.js"></script>

<script>
  const ctx = document.getElementById('myChart');

  new Chart(ctx, {
    type: 'bar',
    data: {
      labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
      datasets: [{
        label: '# of Votes',
        data: [12, 19, 3, 5, 2, 3],
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        y: {
          beginAtZero: true
        }
      }
    }
  });
</script>

<div class="dashboard-hero">
    <div class="container">
        <div class="hero-content">
            <h1 class="hero-title">
                <i class="bi bi-shield-check hero-icon"></i>
                Rules Dashboard
            </h1>
            <p class="hero-subtitle">Comprehensive overview and analytics for all rule types in the system</p>
        </div>
    </div>
</div>

<div class="container dashboard-container">
    <div class="row">
        <div class="col-md-12">
            <!-- Content will follow here -->
        </div>
    </div>

    <div class="row" *ngIf="displayError">
        <div class="alert alert-warning" role="alert">
            {{errorMessage}}
        </div>
    </div>

    <!-- KPI Cards -->
    <div class="row mb-4 kpi-section">
        <div class="col-md-4 mb-3">
            <div class="kpi-card kpi-card-primary">
                <div class="kpi-icon-wrapper">
                    <i class="bi bi-folder-fill kpi-icon"></i>
                </div>
                <div class="kpi-content">
                    <h5 class="kpi-label">Total Rules</h5>
                    <h2 class="kpi-value">{{getTotalRules()}}</h2>
                    <div class="kpi-trend">
                        <i class="bi bi-graph-up-arrow"></i>
                        <span>Active</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 mb-3">
            <div class="kpi-card kpi-card-success">
                <div class="kpi-icon-wrapper">
                    <i class="bi bi-tags-fill kpi-icon"></i>
                </div>
                <div class="kpi-content">
                    <h5 class="kpi-label">Rule Types</h5>
                    <h2 class="kpi-value">{{getRuleTypesCount()}}</h2>
                    <div class="kpi-trend">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Categories</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 mb-3">
            <div class="kpi-card kpi-card-info">
                <div class="kpi-icon-wrapper">
                    <i class="bi bi-clock-history kpi-icon"></i>
                </div>
                <div class="kpi-content">
                    <h5 class="kpi-label">Last Updated</h5>
                    <h6 class="kpi-date">{{getCurrentDate()}}</h6>
                    <div class="kpi-trend">
                        <i class="bi bi-calendar-check"></i>
                        <span>Recent</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="loading" class="loader-overlay">
        <div class="spinner-border text-secondary"></div>
    </div>

    <!-- Charts and Statistics -->
    <div class="row" *ngIf="!loading">
        <div class="col-md-6 mb-4">
            <div class="modern-card chart-card">
                <div class="modern-card-header">
                    <div class="card-title-wrapper">
                        <i class="bi bi-bar-chart-fill card-icon"></i>
                        <h5 class="modern-card-title">Rule Distribution</h5>
                    </div>
                    <div class="header-stats">Total Rules: {{getTotalRules()}}
                    </div>
                </div>
                <div class="modern-card-body">
                    <!-- Chart -->
                    <div class="chart-container">
                        <div class="chartjs-wrapper">
                            <canvas baseChart
                                [data]="barChartData"
                                [options]="barChartOptions"
                                type="bar">
                            </canvas>
                        </div>
                    </div>
                    <hr />
                    <!-- Filter Pills -->
                    <div class="filter-pills-container">
                        <button *ngFor="let filter of ruleTypeFilters; let i = index"
                            class="filter-pill"
                            [class.active]="filter.selected"
                            [style.background-color]="filter.selected ? getFilterColor(filter.ruleType) : 'transparent'"
                            [style.border-color]="getFilterColor(filter.ruleType)"
                            [style.color]="filter.selected ? '#ffffff' : getFilterColor(filter.ruleType)"
                            (click)="toggleRuleTypeFilter(i)">
                            <i class="bi" [ngClass]="filter.selected ? 'bi-check-circle-fill' : 'bi-circle'"></i>
                            {{getShortRuleType(filter.ruleType)}}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6 mb-4">
            <div class="modern-card statistics-card">
                <div class="modern-card-header">
                    <div class="card-title-wrapper">
                        <i class="bi bi-bar-chart-fill card-icon"></i>
                        <h5 class="modern-card-title">Rule Statistics</h5>
                    </div>
                </div>
                <div class="modern-card-body">
                    <div class="modern-table-wrapper" style="overflow: hidden;">
                        <table class="modern-table">
                            <thead>
                                <tr>
                                    <th (click)="onSort('ruleType')" class="sortable-header">
                                        <span class="header-content">
                                            <!-- <i class="bi bi-tag-fill"></i> -->
                                            <i class="bi ms-1 sort-icon" [ngClass]="getSortIcon('ruleType')"></i>
                                            Rule Type
                                        </span>
                                    </th>
                                    <th (click)="onSort('count')" class="sortable-header">
                                        <span class="header-content">
                                            <i class="bi ms-1 sort-icon" [ngClass]="getSortIcon('count')"></i>
                                            <!-- <i class="bi bi-123"></i> -->
                                            Count
                                        </span>
                                    </th>
                                    <th class="action-header">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let stat of filteredRuleStatistics" class="table-row-hover">
                                    <td class="rule-type-cell">
                                        <span class="rule-type-label">{{stat.ruleType}}</span>
                                    </td>
                                    <td>
                                        <span class="modern-badge badge-primary">{{stat.totalCount}}</span>
                                    </td>
                                    <td>
                                        <button class="btn-modern-action btn-action-primary"
                                            (click)="navigateToRuleManagement(stat.ruleType)">
                                            <i class="bi bi-gear-fill"></i>
                                            <span>Manage</span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Quick Actions -->
    <div class="row mt-4" *ngIf="!loading">
        <div class="col-md-12">
            <div class="modern-card quick-actions-card">
                <div class="modern-card-header">
                    <div class="card-title-wrapper">
                        <i class="bi bi-lightning-charge-fill card-icon"></i>
                        <h5 class="modern-card-title">Quick Actions</h5>
                    </div>
                </div>
                <div class="modern-card-body">
                    <div class="row">
                        <div class="col-md-3 col-sm-6 mb-3" *ngFor="let stat of ruleStatistics">
                            <div class="action-card" (click)="navigateToRuleManagement(stat.ruleType)">
                                <div class="action-card-header">
                                    <i class="bi bi-layers-fill action-icon"></i>
                                    <h6 class="action-title">{{stat.ruleType}}</h6>
                                </div>
                                <div class="action-card-body">
                                    <div class="action-count">
                                        <span class="count-value">{{stat.totalCount}}</span>
                                        <span class="count-label">rules</span>
                                    </div>
                                </div>
                                <div class="action-card-footer">
                                    <span class="action-link">
                                        Manage Rules
                                        <i class="bi bi-arrow-right-circle-fill"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>